<template>
  <div>
    <h2>Welcome....</h2>
    <h5> Use navigation bar to goto desired page </h5>
  </div>
</template>  
<script>
    import layout from '@/layout/layout.vue';
    export default {
        name: "dashboard",       
        components: {layout},
        async created() {
         
                    
        }
    }   
</script>